export const stubUser = {
  id: '852219f7-e8c2-4237-93af-8e659db689f1',
  name: 'Temp_User_1'
};
